var map = {
	"./App Store.png": 786,
	"./Google Play.png": 922,
	"./Group 2.png": 846,
	"./Group 4.png": 137,
	"./Group 9.png": 243,
	"./Mask Group 23.png": 726,
	"./MuzicLogo.png": 349,
	"./Path 318.png": 215,
	"./Rectangle 7.png": 507,
	"./backgraphics.png": 997,
	"./d1.png": 86,
	"./d2.png": 722,
	"./d3.png": 379,
	"./d4.png": 985,
	"./music icon.png": 455,
	"./p 1.png": 627,
	"./p 2.png": 724,
	"./p 3.png": 314,
	"./p 4.png": 498,
	"./path.png": 564,
	"./search.png": 132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;